import { computed, ref } from '@vue/composition-api';
import { useQuery } from '@tanstack/vue-query';
import { IUser, User } from '@/models';
import providerInstance from '@/services/provider';

export function useFetchWorkflowFormTemplateRevisionsStakeholderUsers() {
  const queryKey = ref(['template-stakeholder-users']);

  const { isLoading, isError, error, data: users } = useQuery({
    queryKey: queryKey,
    queryFn: () =>
      providerInstance.workflowFormTemplate.fetchWorkflowFormTemplateRevisionsStakeholderUsers(),
    enabled: true,
    select: data => {
      return data.map(user => new User(user));
    }
  });

  return {
    queryKey,
    users: computed<IUser[]>(() => users.value ?? []),
    error,
    isError,
    isLoading: computed<boolean>(() => isLoading.value)
  };
}
